export const HT_FONT = { name: 'Arial', size: 8 };
